import "antd/dist/antd.css";
import "./style/index.css";
import App from "./app";

window.document.title = "Hydroplus Ecosystem";
export default App;
